import Q from 'q';

import API from 'js/lib/api';

type LoginAPIProps = {
  email?: string;
  password?: string;
  verificationCode?: string;
  recaptchaToken?: string | null;
  redirectTo?: string; // redirect url
};

export default ({ email, password, verificationCode: code, recaptchaToken, redirectTo }: LoginAPIProps) => {
  // We need to set the type to rest to send the body back as a json object instead of form data
  const api = API('', { type: 'rest' });

  const data = {
    email,
    password,
    code,
    recaptchaToken,
    redirectTo,
    webrequest: true,
  };

  return Q(api.post('api/login/v3', { data }));
};
